export const WEB_SOCKET_CONNECTION_TRY_COUNT = 5;
export const WEB_SOCKET_MAX_SUCCESS_STATUS = 299;
